<template>
  <b-col sm="12" md="6" lg="4" offset-lg="1">
    <h5 class="vb-heading mb-4">{{ title_form }}</h5>

    <validation-observer v-slot="{ invalid }" ref="observer">
      <b-row v-for="(discount_code, index) in discount_codes" v-bind:key="index">

        <validation-provider rules="required|alpha_num|min:16|max:16" name="Codice sconto" v-slot="{ errors }" :ref="`discount_code_${index}`" class="d-flex w-100">
          <b-col :cols="!is_tb() ? '8' : '12'">
            <vb-input
              v-model="discount_codes[index]"
              :vb_options="{
                autocomplete: 'chrome-off',
                placeholder: 'Es: XXXXXXXXXXXXXXXX',
              }"/>
            <span class="vee--errors">{{ errors[0] }}</span>
          </b-col>
          <b-col
            v-if="!is_tb()"
            cols="4"
            :class=" index > 0 ? 'd-flex pt-3 justify-content-center' : 'd-flex justify-content-center'"
          >
            <vb-icon
              v-if="index>0"
              :name="'minus-circle'"
              :size="20"
              :color="sass('danger')"
              @click.stop="remove_discount_code(index)"
            />
            <div v-else>
              <vb-button
                @click.stop="add_discount_code()"
                :vb_options="{
                  variant: 'primary',
                  text: 'Aggiungi',
                }"
              />
            </div>
          </b-col>
        </validation-provider>
      </b-row>

      <template v-if="show_name_fields">
        <validation-provider ref="observer_name" rules="required|alpha_spaces|min:2" name="Nome" v-slot="{ errors }">
          <b-form-group label="Nome" label-class="vb-label">
            <vb-input
              v-model="name"
              :vb_options="{
                autocomplete: 'chrome-off',
                placeholder: 'Nome',
              }"
            />
          </b-form-group>
          <span class="vee--errors">{{ errors[0] }}</span>
        </validation-provider>

        <validation-provider ref="observer_surname" rules="alpha_spaces|min:2" name="Cognome" v-slot="{ errors }">
          <b-form-group label="Cognome" label-class="vb-label">
            <vb-input
              v-model="surname"
              :vb_options="{
                autocomplete: 'chrome-off',
                placeholder: 'Cognome',
              }"
            />
          </b-form-group>
          <span class="vee--errors">{{ errors[0] }}</span>
        </validation-provider>
      </template>

      <validation-provider ref="observer_email" rules="required|email" name="Email" v-slot="{ errors }">
        <b-form-group label="Email" label-class="vb-label">
          <vb-input
            v-model="email"
            :vb_options="{
              autocomplete: 'chrome-off',
              placeholder: 'email@email.com',
            }"
          />
        </b-form-group>
        <span class="vee--errors">{{ errors[0] }}</span>
      </validation-provider>

      <div class="mt-4">
        <validation-provider :rules="{ required:{ allowFalse: false } }" name="Condizioni d'uso" v-slot="{ errors }">
          <vb-checkbox
            v-model="checkbox_terms"
            :vb_options="{}"
          >
            <router-link :to="{name: 'terms'}" target="_blank" class="nounderline">
              Accetto le condizioni d'uso
            </router-link>
          </vb-checkbox>
          <span class="vee--errors mb-2">{{ errors[0] }}</span>
        </validation-provider>

        <validation-provider :rules="{ required:{ allowFalse: false } }" name="Privacy" v-slot="{ errors }">
          <vb-checkbox
            v-model="checkbox_privacy"
            :vb_options="{}"
          >
            <router-link :to="{name: 'privacy-policy'}" target="_blank" class="nounderline">
              Accetto le condizioni di Privacy
            </router-link>
          </vb-checkbox>
          <span class="vee--errors">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="mt-4">
        <div class="loginButton" v-if="!loading">
          <vb-button
            class="btn-block"
            :vb_options="{
              class: 'btn-block',
              disabled: invalid,
              //size: 'lg',
              text: 'Carica'
            }"
            @click="() => {
              if (recaptcha_enabled) {
                recaptcha()
                return
              }
              dc_login_handler()
            }"
          />
        </div>
        <loader v-else />
      </div>
    </validation-observer>
  </b-col>
</template>

<script>
import { service_handler } from '@/services'

export default {
  name: "discount-code",

  components: {
  },

  props: {
    title_form: {
      type: String,
      default: 'Il tuo codice di autenticazione',
    },
    discount_code_url: {
      type: String,
      default: '',
    },
    name_url: {
      type: String,
      default: '',
    },
    surname_url: {
      type: String,
      default: '',
    },
    email_url: {
      type: String,
      default: '',
    },
  },

  created() {
    // http://localhost:8667/c/Dgbtc04hv4mjAxJy/andrea/rossi/test@email.it/ --> OCCHIO: trailing slash obbligatorio!
    if (this.discount_code_url){
      this.discount_codes = this.discount_code_url.includes(',') ? this.discount_code_url.split(',') : [this.discount_code_url];
    }
    if (this.name_url) this.name = this.name_url
    if (this.surname_url) this.surname = this.surname_url
    if (this.email_url) this.email = this.email_url
  },

  mounted() {
    //if (this.discount_code) this.$refs.observer_discount_code.validate()
    if (this.name && this.$refs.observer_name) this.$refs.observer_name.validate()
    if (this.surname && this.$refs.observer_surname) this.$refs.observer_surname.validate()
    if (this.email) this.$refs.observer_email.validate()
  },

  computed: {
    show_name_fields() {
      return this.get_config('portal') !== 'travel-benefit'
    },
  },

  data() {
    return {
      // dcLogin
      recaptcha_enabled: this.get_config('recaptcha.enabled'),
      loading: false,
      name: '',
      surname: '',
      email: '',
      discount_codes: [''],
      checkbox_terms: false,
      checkbox_privacy: false,
      recaptcha_token: '',
    }
  },

  methods: {

    add_discount_code() {
      this.discount_codes.push('')
      this.$nextTick(() => {
        this.discount_codes.forEach((d,i) => {
          const ref = this.$refs[`discount_code_${i}`][0]
          ref.validate()
        })
      })
    },

    remove_discount_code(index) {
      let new_discount_codes = [
        ...this.discount_codes
      ]
      new_discount_codes.splice(index, 1)
      this.discount_codes = new_discount_codes
    },

    // dcLogin
    async recaptcha() {
      this.loading = true
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('login')
      this.recaptcha_token = token
      this.dc_login_handler()
    },

    dc_login_handler() {
      this.loading = true
      const discountCode = this.discount_codes.join(',')
      this.log(discountCode)
      service_handler('dcLogin', {
        discountCode: discountCode,
        name: this.name,
        surname: this.surname,
        email: this.email,
        recaptcha: this.recaptcha_token,
        micrositeId: this.get_config('site.travelc.micrositeId'),
        agencyId: this.get_config('site.travelc.agencyId'),
      }).then(
        (success) => {
          if (success.data && success.data.redirectTo) {
            if (success.data.redirectTo.startsWith('http://') || success.data.redirectTo.startsWith('https://')) {
              window.location.href = success.data.redirectTo
            } else {
              const resolved = this.$router.resolve(success.data.redirectTo)
              window.location.href = resolved.href
            }
          } else {
            this.loading = false
          }
        },
        () => {
          this.loading = false
        }
      )
    },
  },
}

</script>

<style lang="scss">
</style>